module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container",
    attrs: {
      "id": "mobileViewPort"
    }
  }, [_c('div', {
    attrs: {
      "id": "mobileMode"
    }
  }, [_c('div', {
    attrs: {
      "id": "titleArea"
    }
  }, [_c('div', {
    staticClass: "titleText"
  }, [_vm._v("外考报名")]), _vm._v(" "), _c('div', {
    staticClass: "titleButton"
  }, [_c('el-button', {
    staticClass: "custom-el-button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showHomePage
    }
  }, [_c('i', {
    staticClass: "el-icon-s-home"
  }), _vm._v(" 首页\n                ")])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "queryArea"
    }
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('div', {
    staticClass: "formItem text-center"
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.WKStu
    }
  }, [_c('i', {
    staticClass: "el-icon-document-copy"
  }), _vm._v(" 报名信息")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.personInfoDialogVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v(" 个人信息")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.supplementInfoDialogVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v(" 信息补全")])], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "listArea"
    },
    on: {
      "scroll": _vm.handleScroll
    }
  }, [(_vm.tableData == null || _vm.tableData.length == 0) ? _c('div', {
    staticClass: "cardTips"
  }, [_vm._v("没有科目信息")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cardMain"
    }, [_c('div', {
      staticClass: "cardText"
    }, [_c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("外考考试名称：")]), _vm._v(_vm._s(item.wkksmc))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("报名开始时间：")]), _vm._v(_vm._s(item.bmkssj))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("报名结束时间：")]), _vm._v(_vm._s(item.bmjssj))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("考试日期：")]), _vm._v(_vm._s(item.kssj))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("报名费用：")]), _vm._v(_vm._s(item.ksfy))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("报名人数：")]), _vm._v(_vm._s(item.bmrs))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("备注：")]), _vm._v(_vm._s(item.bz))]), _vm._v(" "), _c('div', {
      staticClass: "auditStateImg"
    }, [(item.sfbm == '1') ? _c('img', {
      attrs: {
        "src": _vm.loadStateImg(item),
        "alt": ""
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "cardInput"
    }, [(item.sfbm !== '1') ? _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.checkBM(item)
        }
      }
    }, [_vm._v("报名\n                    ")]) : _vm._e()], 1)])
  }), _vm._v(" "), (_vm.total > 2 && _vm.total > _vm.tableData.length) ? _c('div', {
    attrs: {
      "id": "loadingTips"
    }
  }, [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" 信息加载中，请稍候...\n            ")]) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "personInfoDialog",
      "title": "个人报名信息",
      "visible": _vm.WKStuDialogVisible,
      "width": "90%",
      "top": "-20px"
    },
    on: {
      "update:visible": function($event) {
        _vm.WKStuDialogVisible = $event
      },
      "open": _vm.queryWKStu
    }
  }, [_c('div', {
    attrs: {
      "id": "mobileMode_person"
    }
  }, [_c('div', {
    attrs: {
      "id": "listArea_person"
    }
  }, [(_vm.WKStuTableData == null || _vm.WKStuTableData.length == 0) ? _c('div', {
    staticClass: "cardTips"
  }, [_vm._v("没有报名记录")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.WKStuTableData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cardMain"
    }, [_c('div', {
      staticClass: "cardText"
    }, [_c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("外考考试名称：")]), _vm._v(_vm._s(item.wkksmc))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("考试日期：")]), _vm._v(_vm._s(item.kssj))])]), _vm._v(" "), _c('div', {
      staticClass: "cardInput"
    }, [(item.sfjf == 0) ? _c('el-button', {
      attrs: {
        "size": "small",
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.delWKSelection(item);
        }
      }
    }, [_vm._v("\n                                删除\n                            ")]) : _vm._e()], 1)])
  })], 2)])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "personInfoDialog",
      "visible": _vm.personInfoDialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.personInfoDialogVisible = $event
      },
      "open": _vm.openSupplementInfoDialog
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "color": "#303133",
      "font-weight": "bold"
    }
  }, [_vm._v("个人信息")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mobileMode_person"
    }
  }, [_c('div', {
    attrs: {
      "id": "listArea_person"
    }
  }, [_c('el-scrollbar', {
    ref: "mainDialogScroll",
    attrs: {
      "id": "mainDialogScroll"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "84px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.personInfoData.xm) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学号"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.personInfoData.xh) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.personInfoData.xb) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "班级"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.personInfoData.bj) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出生年月"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.personInfoData.csny) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身份证号"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.personInfoData.sfzh) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "政治面貌"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.personInfoData.zzmm) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "民族"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.personInfoData.mz) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.personInfoData.lxdh) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电子邮箱"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.personInfoData.dzyx) + "\n                            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "家庭住址"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.personInfoData.jtzz) + "\n                            ")])], 1)], 1)], 1)])], 2), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "personInfoDialog",
      "title": "信息补全",
      "visible": _vm.supplementInfoDialogVisible,
      "width": "90%",
      "top": "-20px"
    },
    on: {
      "update:visible": function($event) {
        _vm.supplementInfoDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "200px",
      "padding": "10px 20px"
    },
    attrs: {
      "id": "mobileMode_person"
    }
  }, [_c('div', {
    attrs: {
      "id": "listArea_person"
    }
  }, [_c('el-scrollbar', [_c('el-form', {
    attrs: {
      "label-width": "84px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系电话"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 30,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.supplementInfoForm.lxdh),
      callback: function($$v) {
        _vm.$set(_vm.supplementInfoForm, "lxdh", $$v)
      },
      expression: "supplementInfoForm.lxdh"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveSupplementInfo
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.supplementInfoDialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fcf851e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/outsideStudentSelection.vue
// module id = 1791
// module chunks = 502